const calculateBookingCost = (roomPrices, checkInDate, checkOutDate) => {
  if (!checkInDate || !checkOutDate) return 0;

  const oneDay = 24 * 60 * 60 * 1000;
  const startDate = new Date(checkInDate);
  const endDate = new Date(checkOutDate);
  startDate.setHours(0, 0, 0, 0);
  endDate.setHours(0, 0, 0, 0);

  const totalDays = Math.max(0, Math.round((endDate - startDate) / oneDay));
  if (totalDays <= 0) return 0;

  const prices = Array.isArray(roomPrices) ? roomPrices : [roomPrices];

  return prices.reduce((sum, room) => {
    const nightlyRate = typeof room === "object" ? room.roomPrice ?? 0 : Number(room) || 0;
    return sum + nightlyRate * totalDays;
  }, 0);
};

export default calculateBookingCost;
